(function () {
  const STORAGE_KEY = 'gb_pincode_last';
  const API_BASE = 'https://api.postalpincode.in/pincode/';

  function normalizePincode(value) {
    return (value || '').replace(/\s+/g, '');
  }

  function isValidPincode(value) {
    return /^\d{6}$/.test(value);
  }

  function parseAllowedPincodes(rawList) {
    return new Set(
      (rawList || '')
        .split(/[\s,]+/)
        .map((item) => item.trim())
        .filter((item) => /^\d{6}$/.test(item))
    );
  }

  function formatDeliveryDate(daysToDeliver) {
    const date = new Date();
    date.setDate(date.getDate() + daysToDeliver);
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).format(date);
  }

  function buildPlaceName(postOffice) {
    if (!postOffice) return '';
    const area = (postOffice.Name || postOffice.Block || '').trim();
    const district = (postOffice.District || '').trim();
    const state = (postOffice.State || '').trim();
    return [area, district, state].filter(Boolean).join(', ');
  }

  function createLine(className, text) {
    const line = document.createElement('p');
    line.className = className;
    line.textContent = text;
    return line;
  }

  function renderLoading(resultEl) {
    resultEl.innerHTML = '';
    resultEl.className = 'gb-pincode-checker__result gb-pincode-checker__result--loading';
    resultEl.appendChild(createLine('gb-pincode-checker__line', 'Checking...'));
  }

  function renderError(resultEl, message) {
    resultEl.innerHTML = '';
    resultEl.className = 'gb-pincode-checker__result gb-pincode-checker__result--error';
    resultEl.appendChild(createLine('gb-pincode-checker__line gb-pincode-checker__line--error', message));
  }

  function renderSuccess(resultEl, config, placeName) {
    const daysLabel = config.daysToDeliver === 1 ? 'day' : 'days';
    const formattedDate = formatDeliveryDate(config.daysToDeliver);

    resultEl.innerHTML = '';
    resultEl.className = 'gb-pincode-checker__result gb-pincode-checker__result--success';

    const statusLine = document.createElement('p');
    statusLine.className = 'gb-pincode-checker__line gb-pincode-checker__line--status';
    statusLine.innerHTML =
      '<span class="gb-pincode-checker__dot" aria-hidden="true"></span><span>Delivery available</span>';
    resultEl.appendChild(statusLine);

    if (config.showPlaceName && placeName) {
      resultEl.appendChild(createLine('gb-pincode-checker__line', 'Delivering to: ' + placeName));
    }

    resultEl.appendChild(
      createLine(
        'gb-pincode-checker__line gb-pincode-checker__line--date',
        'Estimated delivery: ' + formattedDate + ' (' + config.daysToDeliver + ' ' + daysLabel + ')'
      )
    );
    resultEl.appendChild(
      createLine(
        'gb-pincode-checker__helper',
        'Usually delivered in ' + config.daysToDeliver + ' ' + daysLabel
      )
    );
  }

  async function fetchPlaceName(pincode) {
    const response = await fetch(API_BASE + encodeURIComponent(pincode), { method: 'GET' });
    if (!response.ok) {
      throw new Error('API request failed');
    }

    const payload = await response.json();
    const first = Array.isArray(payload) ? payload[0] : null;
    if (!first || first.Status !== 'Success' || !Array.isArray(first.PostOffice) || first.PostOffice.length === 0) {
      return '';
    }

    return buildPlaceName(first.PostOffice[0]);
  }

  function initChecker(container) {
    const input = container.querySelector('[data-gb-pincode-input]');
    const button = container.querySelector('[data-gb-pincode-button]');
    const result = container.querySelector('[data-gb-pincode-result]');

    if (!input || !button || !result) return;

    const config = {
      daysToDeliver: Math.min(10, Math.max(1, Number(container.dataset.daysToDeliver) || 3)),
      showPlaceName: container.dataset.showPlaceName === 'true',
      autoCheckOnLoad: container.dataset.autoCheckOnLoad === 'true',
      allowAllPincodes: container.dataset.allowAllPincodes === 'true',
      allowedPincodes: parseAllowedPincodes(container.dataset.allowedPincodes || '')
    };

    let isChecking = false;

    async function runCheck() {
      if (isChecking) return;

      const normalized = normalizePincode(input.value);
      input.value = normalized;

      if (!isValidPincode(normalized)) {
        renderError(result, 'Enter a valid 6-digit pincode');
        return;
      }

      if (!config.allowAllPincodes && !config.allowedPincodes.has(normalized)) {
        renderError(result, 'Delivery is not available for this pincode');
        return;
      }

      localStorage.setItem(STORAGE_KEY, normalized);

      isChecking = true;
      button.disabled = true;
      renderLoading(result);

      try {
        const placeName = await fetchPlaceName(normalized);
        renderSuccess(result, config, placeName);
      } catch (error) {
        renderSuccess(result, config, '');
      } finally {
        isChecking = false;
        button.disabled = false;
      }
    }

    button.addEventListener('click', runCheck);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        runCheck();
      }
    });

    const savedPincode = normalizePincode(localStorage.getItem(STORAGE_KEY));
    if (savedPincode) {
      input.value = savedPincode;
      if (config.autoCheckOnLoad && isValidPincode(savedPincode)) {
        runCheck();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-gb-pincode-checker]').forEach(initChecker);
  });
})();
